import lockupOnLight from './brand/argink-lockup-onlight.png';
import lockupOnDark from './brand/argink-lockup-ondark.png';
import seloProva from './brand/argink-selo-prova.png';

/**
 * URLs dos assets de marca controlados (ver `PROVENANCE.md` no mesmo diretório).
 * Uso normal é via `BrandMark`/`ProofSeal`; exportado cru aqui só para quem
 * precisar da URL crua (ex.: `<link rel="apple-touch-icon">` custom no HTML raiz
 * do app — não é o caso de favicon/símbolo A-nó, que segue bloqueado).
 */
export const brandAssets = {
  lockupOnLight,
  lockupOnDark,
  seloProva,
} as const;
